import 'preact-cli/lib/lib/webpack/polyfills';

if (!String.prototype.startsWith) {
  // eslint-disable-next-line no-unused-expressions
  import('core-js/es6/string');
}

if (!Array.prototype.includes) {
  // eslint-disable-next-line no-unused-expressions
  import('core-js/es6/array');
}
